import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, ContentService, HelperService, ProductService, ProductSnapshot, UserService, WindowService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { AppService, FirebaseService } from "@mypxplat/xplat/web/core";
import { RegisterSuccessSplashComponent } from "../register-success-splash/register-success-splash.component";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-studioone-grace-period",
  templateUrl: "studioone-grace-period.component.html",
  standalone: false,
})
export class StudiooneGracePeriodComponent extends BaseComponent {
  @Input() asset: any;
  public status: any;
  constructor(
    userService: UserService,
    private _win: WindowService,
    public activeModal: NgbActiveModal,
    public productService: ProductService,
    public router: Router,
    public helperService: HelperService,
    public appService: AppService,
    public fbService: FirebaseService,
    public contentService: ContentService
  ) {
    super(userService);
  }

  ngOnInit() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("clear-modal-content");
    this._win.setTimeout(() => {
      this.appService.showConfetti();
    }, 800);
  }

  view() {
    this.router.navigate(["products/detail/", this.env.product_ids.s17pro]);
    this.activeModal.close();
  }

  public redeeming: boolean = false;
  redeem() {
    this.redeeming = true;
    this.status = "redeeming";
    this.productService.redeemProduct({ id: this.env.product_ids.s18upgrade, oldProductKey: this.productService.upgradableS17Asset.productKeyString }).subscribe({
      next: (result) => {
        this.redeeming = false;
        this.checkForSplash(result.product);
        this.productService.getProducts().subscribe(() => {
          this.status = "success";
        });
      },
      error: (error) => {
        this.status = undefined;
        alert(this.helperService.retrieveErrorMessage(error));
      },
    });
  }

  checkForSplash(product) {
    return new Promise((resolve, reject) => {
      this.fbService.checkForSplash(product.stringId).then((splash) => {
        if (splash) {
          this.showSplash(splash, product);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  showSplash(splash, product) {
    this.activeModal.close();
    const modalRef = this.appService.showModal(RegisterSuccessSplashComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
    modalRef.componentInstance.splash = splash;
    modalRef.componentInstance.productId = product?.id;
    modalRef.componentInstance.productName = product?.title;
    modalRef.componentInstance.isNewRegistration = true;
  }
}
